import { render, staticRenderFns } from "./StemdoerDetail.vue?vue&type=template&id=473da65c&scoped=true"
import script from "./stemdoerDetail.ts?vue&type=script&lang=ts&external"
export * from "./stemdoerDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./StemdoerDetail.vue?vue&type=style&index=0&id=473da65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473da65c",
  null
  
)

export default component.exports